import React from 'react'
import FlagDesktop from './components/FlagDesktop'

type FlagProps = {
  text: string
  className?: string
  fontColor: string
  backgroundColor: string
}

const Flag: React.FC<FlagProps> = ({
  text,
  className,
  fontColor,
  backgroundColor,
}) => {
  return (
    <FlagDesktop
      text={text}
      className={className}
      fontColor={fontColor}
      backgroundColor={backgroundColor}
    />
  )
}

export default Flag
